import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_SUBMITTING_CONTACT = 'SET_SUBMITTING_CONTACT';
const setSubmitting = () => ({
    type: SET_SUBMITTING_CONTACT,
});

export const UNSET_SUBMITTING_CONTACT = 'UNSET_SUBMITTING_CONTACT';
const unsetSubmitting = () => ({
    type: UNSET_SUBMITTING_CONTACT,
});

export const SET_SUBMITTED_CONTACT = 'SET_SUBMITTED_CONTACT';
const setSubmitted = () => ({
    type: SET_SUBMITTED_CONTACT,
});

export const sendMessage = (data) => (dispatch) => {
    dispatch(setSubmitting());

    const query = 'api/v1/contact/sendMessage';

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            if (json.status === 'success') {
                dispatch(setSubmitted());

                showSuccess('Sua mensagem foi enviada! Retornaremos em breve :)');
            } else {
                dispatch(unsetSubmitting()); // might not be necessary here as it is in the final catch

                showError(json.message);

                throw `error from server: ${json.message}`;
            }
        }).catch((error) => {
            dispatch(unsetSubmitting());

            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            throw `message got ${error}`;
        });
};
